<rap-students-ui [students]="students" [rosterId]="rosterID" (deleteStudentEmitter)="deleteStudent($event)"
  (manageStudentEmitter)="manageStudent($event)"></rap-students-ui>